import styled from 'styled-components';

interface TranslateProps {
  yPosition: number;
}

export const Group = styled('g').attrs<TranslateProps>((props) => ({
  style: {
    transform: `translate(44.3%, ${props.yPosition}%)`,
  },
}))<TranslateProps>`
  cursor: move;
  transform-origin: center;
`;

interface RotationProps {
  angle: number;
}

export const RotationGroup = styled('g').attrs<RotationProps>((props) => ({
  style: {
    transform: `rotate(${props.angle}deg)`,
  },
}))<RotationProps>`
  user-select: none;
  transform-origin: center;
`;

const BaseCircle = styled('circle')`
  fill: ${({ theme }) => theme.color.brand01};
  transition: all 0.2s linear;
`;

export const Fill = styled(BaseCircle)`
  opacity: 0.4;
  &:hover {
    opacity: 0.6;
  }
`;

export const Stroke = styled(BaseCircle)`
  opacity: 0.2;
  &:hover {
    opacity: 0.4;
  }
`;

export const Arrows = styled('path')`
  opacity: 0.9;
  fill: ${({ theme }) => theme.color.brand01};
`;

export const WhiteDot = styled('circle')`
  fill: ${({ theme }) => theme.color.white};
  opacity: 0.5;
`;
